import React from 'react';
import { BsFacebook, BsInstagram, BsLinkedin, BsWhatsapp, BsYoutube } from 'react-icons/bs';
import { FaLinkedin, FaInstagram, FaYoutube, FaFacebook } from "react-icons/fa";
import { FiChevronRight } from "react-icons/fi";
import { SiWhatsapp } from 'react-icons/si';

const TopAddressBar = () => {
  return (
    <>
      {/* Optional: Add Kryzen's green as custom CSS variable */}

      <div className="border-bottom border-gray-light bg-white d-none d-lg-flex">
        <div className="container-xl">
          <div className="row align-items-center py-2">

            {/* Left Side - Contact Info */}
            <div className="col-lg-8">
              <div className="d-flex flex-wrap align-items-center gap-4 text-muted small">

                {/* Email */}
                <div className="d-flex align-items-center gap-2">
                  <i className="ti ti-mail icon icon-kryzen"></i>
                  <span>Call Us:</span>
                  <a href="phoneto:9870-424-425" className="text-kryzen text-decoration-none fw-medium">
                  9870-424-425
                  </a>
                  <span>(Mon-Sat: 09:00am – 06:00pm)</span>
                </div>

             

           
              </div>
            </div>

            {/* Right Side - WhatsApp + Social Icons */}
            <div className="col-lg-4 text-end">
              <div className="d-flex align-items-center justify-content-end gap-3">

                {/* WhatsApp Button */}
                <a
                  href="https://wa.me/message/IDT552JR5HVYE1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm bg-whatsapp  d-flex align-items-center gap-1 px-3"
                >
                  <SiWhatsapp color='green' />
                  Connect on WhatsApp
                </a>

                {/* Social Icons */}
                <div className="d-flex gap-2">
                  <a href="https://www.youtube.com/c/HydroponicMasterclass" target="_blank" rel="noopener noreferrer"
                     className=" bg-white border-0 text-muted hover:text-danger">
                    <BsYoutube  size={20} />
                  </a>
                  <a href="https://www.facebook.com/kryzen.biotech.pvt.ltd/" target="_blank" rel="noopener noreferrer"
                     className=" bg-white border-0 text-muted hover:text-primary">
                        <BsFacebook size={20} />
                  </a>
                  <a href="https://www.instagram.com/kryzen_biotech/" target="_blank" rel="noopener noreferrer"
                     className=" bg-white border-0 text-muted hover:text-instagram">
                        <BsInstagram size={20} />
                  </a>
                  <a href="https://www.linkedin.com/company/75561709/" target="_blank" rel="noopener noreferrer"
                     className="  bg-white  text-muted hover:text-linkedin" style={{border:'0 px'}}>
                        <FaLinkedin size={18}   />
                  </a>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default TopAddressBar;